module.exports = __webpack_public_path__ + "img/newParts2.d9b3b7cf.svg";